var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00f6ef;}.cls-2{fill:#ff004f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.27,214.69V146.55c-89.08-3.75-91.89-84.69-92-92.3v-.57H254.49V319.06h0a54.5,54.5,0,1,1-38.64-52.18V196.59A123.49,123.49,0,1,0,323.43,319.06c0-1.73-.05-3.45-.12-5.16V183.22C355,212.22,415.27,214.69,415.27,214.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.54,231.47V163.33c-89.08-3.76-91.89-84.7-92-92.3v-.58H274.76V335.84h0a54.54,54.54,0,1,1-38.64-52.18V213.37A123.49,123.49,0,1,0,343.7,335.84c0-1.73-.05-3.45-.12-5.16V200C375.28,229,435.54,231.47,435.54,231.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325,70.45c3.32,18.07,13,46.34,41.28,62.87-21.6-25.15-22.7-57.61-22.74-62.29v-.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M435.54,231.47V163.33a127.94,127.94,0,0,1-20.27-2.42v53.66s-60.26-2.47-92-31.46V313.78c.07,1.72.12,3.43.12,5.16a123.49,123.49,0,0,1-191.9,102.81A123.48,123.48,0,0,0,343.7,335.84c0-1.73-.05-3.45-.12-5.16V200C375.28,229,435.54,231.47,435.54,231.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.85,266.76a54.56,54.56,0,0,0-39.63,101.31,54.54,54.54,0,0,1,59.9-84.41V213.37a124.69,124.69,0,0,0-15.91-1c-1.46,0-2.91,0-4.36.09Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.6b5144703634f7d8cd46cc7e54d9e02c.svg";
export { ForwardRef as ReactComponent };